import { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../../../providers/AuthProvider';
import { useApi } from '@backstage/core-plugin-api';
import { pocHubApiRef } from '../../../apis/pocHubApi';

// Define the types for team and member based on your API response
interface TeamMember {
  id: string;
  teamid: string;
  email: string;
  displayname: string;
  isprimary: string;
}

interface TeamInfo {
  id: string;
  name: string;
  primarycontact: string;
  description: string;
  isactive: string;
  role: string;
  score: string;
  votes: string;
  eventid: string;
  acceptNewMembers: boolean;
  category: string;
  crossfunctional: boolean;
  collaboratorroles: string[];
  idea_details: {
    theme: string;
    segment: string;
    main_idea: string;
    impact: string;
  };
  thumbnail: string;
  links: any[];
  tags: any[];
  createdat: string;
  updatedat: string;
}

interface TeamApiResponse {
  team: TeamInfo;
  members: TeamMember[];
}

export function useTeams() {
  const authContext = useContext(AuthContext);
  const { profEmail } = authContext;
  const pocHubApi = useApi(pocHubApiRef);

  const [isInTeam, setIsInTeam] = useState(false);
  const [userTeam, setUserTeam] = useState<TeamApiResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchTeams() {
      setLoading(true);
      setError(null);
      try {
        const data: TeamApiResponse[] = await pocHubApi.getHackathonTeams();
        const found = data.find(teamObj =>
          teamObj.members.some(member =>
            member.email?.toLowerCase() === profEmail?.toLowerCase()
          )
        );
        console.log('Fetched teams:', data, 'User email:', profEmail, 'Found team:', found);
        setIsInTeam(!!found);
        setUserTeam(found || null);
      } catch (err: any) {
        setError(err.message || 'Failed to fetch teams');
        setIsInTeam(false);
        setUserTeam(null);
      } finally {
        setLoading(false);
      }
    }
    if (profEmail) {
      fetchTeams();
    }
  }, [profEmail, pocHubApi]);

  return { isInTeam, userTeam, loading, error };
}
